/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_GL (state, gl) {
    state.gl = gl
  },
  REMOVE_RECORD (state, itemId) {
    const glIndex = state.gl.findIndex((u) => u.id === itemId)
    state.gl.splice(glIndex, 1)
  }
}
